<ng-content select="[slot=before]" />

<label for="file-upload" #label>
    <input id="file-upload" type="file">
    <button color="green" (click)="label.click()">
        <ng-content />
    </button>

    @if (fileName) {
        <span>{{fileName}}</span>
    }
</label>
